//product-productline-carousel.js

document.addEventListener('DOMContentLoaded', function() {
  const carousel = document.getElementById('product-carousel');
  const carouselContainer = document.getElementById('carousel-container');
  const prevBtn = document.getElementById('carousel-prev');
  const nextBtn = document.getElementById('carousel-next');
  
  if (!carousel || !prevBtn || !nextBtn || !carouselContainer) return;
  
  const slides = carousel.children;
  const totalSlides = slides.length;
  
  if (totalSlides === 0) return;
  
  let isScrolling = false;
  
  function getSlidesToShow() {
      if (window.innerWidth >= 1024) return 3; // Desktop: show 3, scroll by 3
      if (window.innerWidth >= 768) return 2;  // Tablet: show 2, scroll by 2
      return 1; // Mobile: show 1, scroll by 1
  }
  
  function getSlideWidth() {
      if (slides.length === 0) return 0;
      const computedStyle = getComputedStyle(carousel);
      const gap = parseFloat(computedStyle.gap) || 48; // fallback gap
      return slides[0].offsetWidth + gap;
  }
  
  function updateButtons() {
      const container = carouselContainer;
      const scrollLeft = container.scrollLeft;
      const scrollWidth = container.scrollWidth;
      const clientWidth = container.clientWidth;
      
      // More precise detection with smaller tolerance
      const tolerance = 5;
      const isAtStart = scrollLeft <= tolerance;
      const isAtEnd = scrollLeft >= (scrollWidth - clientWidth - tolerance);
      
      prevBtn.disabled = isAtStart;
      nextBtn.disabled = isAtEnd;
  }
  
  function smoothScrollBy(distance) {
      if (isScrolling) return;
      isScrolling = true;
      
      carouselContainer.scrollBy({
          left: distance,
          behavior: 'smooth'
      });
      
      // Reset scrolling flag and update buttons after animation
      setTimeout(() => {
          isScrolling = false;
          updateButtons();
      }, 400); // Slightly longer timeout for smooth scrolling
  }
  
  function nextSlide() {
      const slideWidth = getSlideWidth();
      const slidesToShow = getSlidesToShow();
      smoothScrollBy(slideWidth * slidesToShow);
  }
  
  function prevSlide() {
      const slideWidth = getSlideWidth();
      const slidesToShow = getSlidesToShow();
      smoothScrollBy(-slideWidth * slidesToShow);
  }
  
  // Event listeners - desktop only
  prevBtn.addEventListener('click', prevSlide);
  nextBtn.addEventListener('click', nextSlide);
  
  // Update buttons on scroll - with debouncing
  let scrollTimeout;
  carouselContainer.addEventListener('scroll', function() {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(updateButtons, 50); // Debounce scroll events
  });
  
  // Handle window resize
  let resizeTimeout;
  window.addEventListener('resize', function() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
          updateButtons();
      }, 100);
  });
  
  // Initialize with a slight delay to ensure everything is rendered
  setTimeout(() => {
      updateButtons();
  }, 100);
});